export const acl: any = {
  // 1-dashboard
  dashboard: {
    module: "dashboard",
    dashboard_kpi: "dashboard_kpi",
    region_wise_medals_graph: "region_wise_medals_graph",
    quarter_wise_medals_graph: "quarter_wise_medals_graph",
    individual_indicators_graph: "individual_indicators_graph",
    performance_indicators_graph: "performance_indicators_graph",
    heat_map_table: "heat_map_table",
    performance_of_all_centres_medals: "performance_of_all_centres_medals",
  },

  // 2-leaderboard
  leaderboard: {
    module: "leaderboard",
  },

  // // 3-configuration
  configuration: {
    module: "configuration",
    manage_score: "manage_score",
    manage_award: "manage_award",
    targets: "targets",
  },

  // // 4-target_achivement
  target_achievements: {
    module: "target_achievements",
    operrations_hr_data: "operrations_hr_data",
    operations_finance_format: "operations_finance_format",
    center_quarter_target: "center_quarter_target",
    center_visit_score: "center_visit_score",
    attendance: "attendance",
    governance_and_ethics: "governance_and_ethics",
    master_center_list: "master_center_list",
    session_quality_data: "session_quality_data",
    sixer_class_data: "sixer_class_data",
    staff_training_data: "staff_training_data",
    funder_satisfaction_score: "funder_satisfaction_score",
    funder_audit_score: "funder_audit_score",
    employee_feedback_score: "employee_feedback_score",
    youth_feedback_score: "youth_feedback_score",
    target_achievement_submodule: "target_achievement_submodule",
    hiring_drive_student_participation: "hiring_drive_student_participation",
    certification_data: "certification_data",
    bolt_module_completion: "bolt_module_completion",
    mock_interviews: "mock_interviews",
    final_employability: "final_employability",
  },

  // 5-data_input
  data_input: {
    module: "data_input",
    operrations_hr_data: "operrations_hr_data",
    operations_finance_format: "operations_finance_format",
    center_quarter_target: "center_quarter_target",
    center_visit_score: "center_visit_score",
    attendance: "attendance",
    governance_and_ethics: "governance_and_ethics",
    master_center_list: "master_center_list",
    session_quality_data: "session_quality_data",
    sixer_class_data: "sixer_class_data",
    staff_training_data: "staff_training_data",
    funder_satisfaction_score: "funder_satisfaction_score",
    funder_audit_score: "funder_audit_score",
    employee_feedback_score: "employee_feedback_score",
    youth_feedback_score: "youth_feedback_score",
    hiring_drive_student_participation: "hiring_drive_student_participation",
    certification_data: "certification_data",
    bolt_module_completion: "bolt_module_completion",
    mock_interviews: "mock_interviews",
    final_employability: "final_employability",
  },

  // 6-user_management
  user_management: {
    module: "user_management",
    user: "user",
    role: "role",
    project: "project",
  },

  // 7-report
  reports: {
    module: "reports",
    parameter_wise: "parameter_wise",
    medal_wise: "medal_wise",
    score_wise: "score_wise",
    target_vs_achievement: "target_vs_achievement",
    attendance: "attendance",
    summary_report: "summary_report",
  },

  // 8-centers
  centres: {
    module: "centres",
  },
};
